import { settings } from './constants';
import { get } from '../shared/services/FetchService';
import EsiGeo from '../../assets/components/fsUtils/EsiGeo';

class Videos {
	constructor() {
		this.liveVideos = [];
		this.featureVideos = [];
		this.allLiveVideosCount = 0;
	}
}

class FsgoVideosServices {
	constructor() {
		this.getVideosProm = {};
	}

	getVideos(data){
		let seQueryParams = '';
		let promName = data.isFifaWC ? 'fifaWC' : (data.regionalIds ||  'zip');
        if (data.isSE) {
        	let wcDay = this.getParameterByName('wc_day');
        	let wcHour = this.getParameterByName('wc_hour');

        	if (wcDay) seQueryParams += `&wc_day=${wcDay}`;
        	if (wcHour) seQueryParams += `&wc_hour=${wcHour}`;

        	promName += 'se' + seQueryParams;
        }

		if (this.getVideosProm[promName]) {
			return this.getVideosProm[promName];
		}

		const isSF = data.postType === settings.SF_POST_TYPE;

		let zip = data.isFifaWC ? '' : EsiGeo.zip || '';

		let queryParams = data.regionalIds
			? `ids=${data.regionalIds}&type=${isSF ? settings.REGIONAL_SF : settings.REGIONAL_POST}`
			: `zip=${zip}&type=${isSF ? settings.NATIONAL_SF : settings.NATIONAL_POST}`;

        queryParams += `&size=${data.videosItemSize || '0'}`;

        if (data.isFifaWC) queryParams += `&wc=1`;
        if (data.isSE) queryParams += `&se=1${seQueryParams}`;

		this.getVideosProm[promName] = get(`${settings.PROGS_URL}?${queryParams}`,
			json => {
				let result = new Videos();

				result.allLiveVideosCount = json.live.allCount;
				result.regionNames = json.regionNames;
				result.liveVideos = getItemsFromProg(json.live);
				result.featureVideos = getItemsFromProg(json.featured);
				result.liveMatchVideos = getItemsFromProg(json.liveMatches);
				result.featuredMatchVideos = getItemsFromProg(json.featuredMatches);

				return result;
			},
			() => new Videos());

		return this.getVideosProm[promName];
	}

	getAuthStatus() {
		return new Promise((resolve, reject) => {
			if (!window.bamtechAuthReady) {
				resolve({});
				return;
			}

            window.bamtechAuthReady.then((status) => resolve(status));
		});
	}

	isViewAllSeparatorShown(regionNames, isLive) {
		if (!regionNames || regionNames.length === 0) {
			return true;
		}

		if (regionNames.length === 1 && regionNames[0].length < (isLive ? 21 : 27)) {
			return true;
		}

		return false;
	}

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}

function getItemsFromProg(prog) {
	if (prog && prog.count > 0) {
		return prog.items || [];
	}

	return [];
}

export default new FsgoVideosServices();



// WEBPACK FOOTER //
// ./react-app-src/fsgo/FsgoVideosService.js